import { VectorMap } from '@react-jvectormap/core';
import { worldMill } from '@react-jvectormap/world';

export default function CountryMap({ mapColor }) {
  return (
    <VectorMap
      map={worldMill}
      backgroundColor="transparent"
      markerStyle={{
        initial: { fill: '#465FFF', r: 5 },
      }}
      markersSelectable={true}
      markers={[
        { latLng: [37.2580397, -104.657039], name: 'USA' },
        { latLng: [20.7504374, 73.7276105], name: 'India' },
        { latLng: [53.613, -11.6368], name: 'Ireland' },
        { latLng: [-25.0304388, 115.2092761], name: 'Australia' },
      ]}
      zoomOnScroll={false}
      zoomMax={12}
      zoomMin={1}
      zoomAnimate={true}
      zoomStep={1.5}
      regionStyle={{
        initial: {
          fill: mapColor || '#D0D5DD',
          fillOpacity: 1,
          stroke: '#fff',
          strokeWidth: 0.5,
          strokeOpacity: 1,
        },
        hover: { fill: '#E2E8F0', cursor: 'pointer' },
        selected: { fill: '#94A3B8' },
        selectedHover: { fill: '#64748B' },
      }}
      regionLabelStyle={{
        initial: { fill: '#35373e', fontWeight: 400, fontSize: '12px' },
        hover: { fill: '#000' },
        selected: { fill: '#000' },
        selectedHover: { fill: '#000' },
      }}
    />
  );
}
